import React from "react";
import _ from "lodash";
import { ReactEntity, ReactEntityComponentType } from "../processors";

export interface ReactProps extends ReactEntity {
    data?: any;
    extraProps?: any;
}

export const ReactComponent: React.FC<ReactProps> = ({ component, properties, data, extraProps }) => {
    const { ProviderSearchBox } = require("../ProviderSearchBox");
    const { ProviderFilterWithFetch } = require("../ProviderFilter");
    const { ProviderList } = require("../ProviderList");
    const { ProviderInfo } = require("../ProviderInfo");
    const { SearchPageMap } = require("../Map");
    const { CategoryDisplayWithContext } = require("../Container");

    const { ProviderCategoryDescription, CategoryDescription } = require("../CategoryDescription");
    const { CategorySupportingInfo } = require("../CategorySupportingInfo");

    const componentDesc: Record<ReactEntityComponentType, any> = {
        providerSearchBox: ProviderSearchBox,
        providerSearchOptionSet: ProviderFilterWithFetch,
        providerList: ProviderList,
        providerInfo: ProviderInfo,
        searchPageMap: SearchPageMap,
        categoryDisplay: CategoryDisplayWithContext,
        categoryDescription: CategoryDescription,
        categorySupportingInfo: CategorySupportingInfo,
        providerCategoryDescription: ProviderCategoryDescription
    };

    if (!componentDesc[component]) return null;

    const componentClass = componentDesc[component];
    const prop = {};

    _.split(properties ?? "", ";").forEach(keyValue => {
        const kv = _.split(keyValue ?? "", "=");

        if (kv[0] != null && kv[1] != null) {
            prop[kv[0].trim()] = kv[1].trim();
        }
    });

    return (
        <>
            {React.createElement(componentClass, {
                ...prop,
                data,
                extraProps
            })}
        </>
    );
};
